import React, { useCallback } from 'react';
import { useStyles } from '../RGZButtons.styles';
import { ButtonOne } from '../../../components/ButtonOne/ButtonOne.component';
import TooltipOne from '../../../components/TooltipOne/TooltipOne.component';
import DeleteIcon from '@mui/icons-material/Delete';

interface PropsRemoveRGZButton {
  isDisabled?: boolean;
  examTaskGroupSolutionScoreIds?: string[];
  removeRGZFunction: (ids: string[]) => void;
}

const RemoveRGZButton: React.FC<PropsRemoveRGZButton> = (props) => {
  const classes = useStyles();

  const buttonText = 'Usuń przypisanie RGZ';

  const handleClick = useCallback(() => {
    props.removeRGZFunction(props.examTaskGroupSolutionScoreIds ? props.examTaskGroupSolutionScoreIds : []);
  }, [props.isDisabled]);

  return (
    <TooltipOne title="Usuń przypisanie RGZ" placement="bottom-start">
      <ButtonOne
        color="inherit"
        variant="contained"
        disabled={props.isDisabled}
        className={props.isDisabled ? classes.disableButton : classes.activeButton}
        style={{ backgroundColor: '#BC0000' }}
        startIcon={!props.isDisabled ? <DeleteIcon /> : undefined}
        onClick={handleClick}
      >
        {buttonText}
      </ButtonOne>
    </TooltipOne>
  );
};

export default RemoveRGZButton;
